import CollectionsSet from './CollectionsSet'

export default CollectionsSet
